import { Col, Input, Row, Select, Tooltip, Icon } from 'antd';
import React, { Component } from 'react';
import { fieldRomaji } from './../../../../services/fieldRequired';
import { CheckFullSizeHalfSize } from './../../../../services/helper';
import { regexIsRomanji, regexPhone } from './../../../../services/ruleValidate';
import { orderStatus } from '../../../../constants'
import { noPostalCodeValidationCountries, noPostalCodeCountries, GSTPaidFlagCountries } from '../../../../services/fieldRequired'
import { postalCodeLength } from '../../../../services/constant'
import { renderDestinationCountries } from './../../../../components/render-select';
import './styles.css';

const Option = Select.Option

class ShipToComponent extends Component {
    checkPostalCode = (value, column) => {
        const { classes, information } = this.props
        let postal_code_length = 7
        if(!noPostalCodeValidationCountries.includes(information.country)){
            postal_code_length = postalCodeLength[information.country]
            if (value.length === postal_code_length && value !== "9999999") {
                this.props.checkPostalCode(value)
            } else {
                classes.postal_code = 'warring'
                this.props.onChangeClasses(classes)
                this.props.onChangeInformation({ value: 9999999, column })
            }
        }else{
            if(!value){
                classes.postal_code = 'error'
            }else if(value.length !== postal_code_length){
                classes.postal_code = 'warring'
                this.props.onChangeClasses(classes)
            }else{
                classes.postal_code = ''
            }
            this.props.onChangeClasses(classes)
        }
    }

    onChange = (value, column, maxLength) => {
        if (fieldRomaji.indexOf(column) === -1 || column === 'email') {
            let wordMax = CheckFullSizeHalfSize(value, maxLength)
            if (!wordMax) return;
        }

        if ((column === 'email' && value && !regexIsRomanji(value))) {
            if (value.trim() === "") {
                this.props.onChangeInformation({ value, column })
            }
            return
        }

        if(column === 'phone' && !regexPhone(value)) {
            let ArrValue = value.split('')
            let filterData = ArrValue.filter((e, i) => {
                return regexPhone(e) === true
            })
            value = filterData.join('')
        }

        if (column === 'name') {
            if(value) {
                this.props.onChange({ value: true, column: 'focusName' })
            } else {
                this.props.onChange({ value: false, column: 'focusName' })
            }
        }
        this.props.pageType === 'editOrder' && this.props.onChange({value: false, column: 'buttonEditOrderDisabled'})
        this.props.onChangeInformation({ value, column })
    }

    onChangeCountry = (value) => {
        const { classes } = this.props
        const { items } = this.props.order
        this.props.onChangeInformation({ value, column: 'country' })
        this.props.pageType === 'editOrder' && this.props.onChange({value: false, column: 'buttonEditOrderDisabled'})
        if(noPostalCodeCountries.includes(value)){
            this.props.onChangeInformation({ value:'' , column: 'postal_code' })
        }
        if(!GSTPaidFlagCountries.includes(value)){
            for(let i = 0; i < items.length; i++){
                items[i].gst_paid = false
            }
        }
        if(!this.props.information.country){
            classes['country'] = ''
            this.props.onChangeClasses(classes)
        }
    }

    render() {
        const { classes, information, order, pageType } = this.props
        let toViewPostalCode = false
        if(!noPostalCodeCountries.includes(information.country)){
            toViewPostalCode = true
        }
        return (
            <Col span={16} id="ship-to">
                <Row gutter={16}>
                    <Col span={4}>
                        <h1 className='title'>SHIP TO</h1>
                    </Col>
                    <Col span={10}>
                        <Row gutter={16}>
                            <Col span={12}>
                                <div className="customer title">
                                    <h3 className='title-field'>Customer #</h3>
                                    <Input
                                        onChange={e => this.onChange(e.target.value, 'customer')}
                                        maxLength={60}
                                        className={classes['customer']}
                                        disabled
                                        value={information.customer}
                                        onBlur={e => this.props.onBlur(e.target.value, 'customer')}
                                    />
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="channel-customer title">
                                    <h3 className='title-field'>Channel Customer #</h3>
                                    <Input
                                        onChange={e => this.onChange(e.target.value, 'channel_customer')}
                                        maxLength={60}
                                        className={classes['channel-customer']}
                                        disabled
                                        value={information.channel_customer}
                                        onBlur={e => this.props.onBlur(e.target.value, 'channel_customer')}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <div className="name title">
                                    <h3 className='title-field'>NAME</h3>
                                    <Tooltip
                                        placement="bottomLeft"
                                        visible={order.tooltip === 'name'}
                                        title={order.message}
                                        overlayClassName='tooltip-error'
                                    >
                                        <Input
                                            maxLength={60}
                                            className={classes['name']}
                                            onChange={e => this.onChange(e.target.value, 'name', 60)}
                                            onBlur={e => this.props.onBlur(e.target.value, 'name')}
                                            onFocus={e => {
                                                this.props.validateEmpty(e.target.value, 'name')
                                                this.props.onFocus(e.target.value, 'name', pageType)
                                            }}
                                            value={information.name}
                                            disabled={information.save_item || information.status_id === orderStatus.SPLIT}
                                        />
                                    </Tooltip>
                                </div>
                                <div className="phone title">
                                    <h3 className='title-field'>NAME IN ALPHABET</h3>
                                    <Tooltip
                                        placement="bottomLeft"
                                        visible={order.tooltip === 'yomigana'}
                                        title={order.message}
                                        overlayClassName='tooltip-error'
                                    >
                                        <Input
                                            type="text"
                                            id="phone"
                                            onChange={e => this.onChange(e.target.value, 'yomigana', 60)}
                                            onBlur={e => this.props.onBlur(e.target.value, 'yomigana')}
                                            onFocus={e => {
                                                this.props.validateEmpty(e.target.value, 'yomigana')
                                                this.props.onFocus(e.target.value, 'yomigana')
                                            }}
                                            maxLength={60}
                                            className={classes['yomigana']}
                                            value={information.yomigana}
                                            disabled={information.save_item || information.status_id === orderStatus.SPLIT}
                                        />
                                    </Tooltip>
                                </div>
                                <div className="phone title">
                                    <h3 className='title-field'>PHONE</h3>
                                    <Tooltip
                                        placement="bottomLeft"
                                        visible={order.tooltip === 'phone'}
                                        title={order.message}
                                        overlayClassName='tooltip-error'
                                    >
                                        <Input
                                            onChange={e => this.onChange(e.target.value, 'phone', 14)}
                                            onBlur={e => this.props.onBlur(e.target.value, 'phone')}
                                            className={classes['phone']}
                                            onFocus={e => {
                                                this.props.validateEmpty(e.target.value, 'phone')
                                                this.props.onFocus(e.target.value, 'phone')
                                            }}
                                            maxLength={14}
                                            value={information.phone}
                                            disabled={information.save_item || information.status_id === orderStatus.SPLIT}
                                        />
                                    </Tooltip>
                                </div>
                                <div className="email title">
                                    <h3 className='title-field'>EMAIL</h3>
                                    <Tooltip
                                        placement="bottomLeft"
                                        visible={order.tooltip === 'email'}
                                        title={order.message}
                                        overlayClassName='tooltip-error'
                                    >
                                        <Input
                                            type="email"
                                            id="email"
                                            onChange={e => this.onChange(e.target.value, 'email', 60)}
                                            maxLength={60}
                                            onFocus={(e) => this.props.onFocus(e.target.value, 'email')}
                                            onBlur={(e) => this.props.onBlur(e.target.value, 'email')}
                                            className={classes['email']}
                                            value={information.email}
                                            disabled={information.save_item || information.status_id === orderStatus.SPLIT}
                                        />
                                    </Tooltip>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={10}>
                        <Row gutter={16}>
                            <Col span={12}>
                                <div className="gutter-box">
                                    <h3 className='title-field'>COUNTRY</h3>
                                    <Select
                                        style={{ width: '100%' }}
                                        onChange={value => this.onChangeCountry(value)}
                                        value={information.country}
                                        disabled={information.save_item || information.status_id === orderStatus.SPLIT}
                                        className={`select-gutter-box ${classes['country']}`}
                                    >
                                        { renderDestinationCountries(String(order.shipperInformation.destinationCountriesCH), information.channel_short_name) }
                                    </Select>
                                </div>
                            </Col>
                            <Col span={12}>
                            { toViewPostalCode ?
                                <div className="postal-code title">
                                    <h3 className='title-field'>POSTAL CODE</h3>
                                    <Tooltip
                                        placement="bottomLeft"
                                        visible={order.tooltip === 'postal_code'}
                                        title={order.message}
                                        overlayClassName='tooltip-warring-postcode'
                                    >
                                        <Input
                                            type="text"
                                            className={`postal-code ${classes['postal_code']}`}
                                            onChange={e => this.onChange(e.target.value.replace(/[^\d]/, ''), 'postal_code')}
                                            maxLength={7}
                                            onBlur={e => {
                                                this.props.order.tooltip = ''
                                                this.props.onBlur(e.target.value, 'postal_code')
                                                return this.checkPostalCode(e.target.value, 'postal_code')
                                            }}
                                            value={information.postal_code}
                                            onFocus={e =>  this.props.validateEmpty(e.target.value, 'postal_code') }
                                            disabled={information.save_item || information.status_id === orderStatus.SPLIT}
                                            suffix={<Icon type="exclamation"/>}
                                        />
                                    </Tooltip>
                                </div>
                                : ""
                            }
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <div className="address1 title">
                                    <h3 className='title-field'>ADDRESS1</h3>
                                    <Tooltip
                                        placement="bottomLeft"
                                        visible={order.tooltip === 'address1'}
                                        title={order.message}
                                        overlayClassName='tooltip-error'
                                    >
                                        <Input
                                            type="text"
                                            id="address1"
                                            onChange={e => this.onChange(e.target.value, 'address1', 100)}
                                            maxLength={100}
                                            onBlur={e => this.props.onBlur(e.target.value, 'address1')}
                                            className={classes['address1']}
                                            onFocus={e => {this.props.validateEmpty(e.target.value, 'address1')
                                                            this.props.onFocus(e.target.value, 'address1')
                                                        }}
                                            value={information.address1}
                                            disabled={information.save_item || information.status_id === orderStatus.SPLIT}
                                        />
                                    </Tooltip>
                                </div>
                                <div className="address2 title">
                                    <h3 className='title-field'>ADDRESS2</h3>
                                    <Tooltip
                                        placement="bottomLeft"
                                        visible={order.tooltip === 'address2'}
                                        title={order.message}
                                        overlayClassName='tooltip-error'
                                    >
                                        <Input
                                            type="text"
                                            id="address2"
                                            onBlur={e => this.props.onBlur(e.target.value, 'address2')}
                                            className={classes['address2']}
                                            onChange={e => this.onChange(e.target.value, 'address2', 100)}
                                            maxLength={100}
                                            onFocus={e => {this.props.validateEmpty(e.target.value, 'address2')
                                                            this.props.onFocus(e.target.value, 'address2')
                                                        }}
                                            value={information.address2}
                                            disabled={information.save_item || information.status_id === orderStatus.SPLIT}
                                        />
                                    </Tooltip>
                                </div>
                                <div className="address3 title">
                                    <h3 className='title-field'>ADDRESS3</h3>
                                    <Tooltip
                                        placement="bottomLeft"
                                        visible={order.tooltip === 'address3'}
                                        title={order.message}
                                        overlayClassName='tooltip-error'
                                    >
                                        <Input
                                            type="text"
                                            id="address3"
                                            className={classes['address3']}
                                            onChange={e => this.onChange(e.target.value, 'address3', 100)}
                                            onBlur={e => this.props.onBlur(e.target.value, 'address3')}
                                            onFocus={e => this.props.onFocus(e.target.value, 'address3')}
                                            maxLength={100}
                                            value={information.address3}
                                            disabled={information.save_item || information.status_id === orderStatus.SPLIT}
                                        />
                                    </Tooltip>
                                </div>
                                <div className="address4 title">
                                    <h3 className='title-field'>ADDRESS4</h3>
                                    <Tooltip
                                        placement="bottomLeft"
                                        visible={order.tooltip === 'address4'}
                                        title={order.message}
                                        overlayClassName='tooltip-error'
                                    >
                                        <Input
                                            type="text"
                                            id="address4"
                                            className={classes['address4']}
                                            onChange={e => this.onChange(e.target.value, 'address4', 100)}
                                            maxLength={100}
                                            value={information.address4}
                                            onBlur={e => this.props.onBlur(e.target.value, 'address4')}
                                            onFocus={e => this.props.onFocus(e.target.value, 'address4')}
                                            disabled={information.save_item || information.status_id === orderStatus.SPLIT}
                                        />
                                    </Tooltip>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
        )
    }
}

export default ShipToComponent



// WEBPACK FOOTER //
// ./src/containers/orders/components/ship-to/index.js